module.exports = __webpack_public_path__ + "static/media/iphone-img-memory.651598f6.svg";